const CASTING_ACTION_TYPES = {
  LOAD_CASTING: 'casting/LOAD_CASTING',
};

export default CASTING_ACTION_TYPES;
